import { render } from "./HeadTraining.vue?vue&type=template&id=1d8bef1f&ts=true"
import script from "./HeadTraining.vue?vue&type=script&lang=ts"
export * from "./HeadTraining.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__